const locale = {
	pageTitle: '负责任矿产采购政策 | 擎亿精密有限公司',
	pageDesc:
		'擎亿精密负责任矿产采购政策。遵循 RBA 与 OECD 尽职调查指南，确保锡、钽、钨、金（3TG）等金属来源无冲突且可追溯，要求供应商回复 CMRT／EMRT 并签署无冲突金属宣告书。',
	pageKeywords:
		'负责任矿产采购政策, 冲突矿产, 3TG, RBA, OECD 尽职调查, CMRT, EMRT, 无冲突金属宣告书, 擎亿精密',
	title: '负责任矿产采购政策',
	subtitle: 'Responsible Minerals Sourcing Policy',
	clickHint: '点击图片可放大查看',
	intro:
		'为落实负责任的矿产采购方式，支持人权与永续发展，擎亿精密有限公司承诺遵循责任商业联盟（RBA）之标准，并持续监督与改善与冲突矿产来源相关之议题。擎亿精密避免直接或间接资助位于冲突影响与高风险地区之非法组织，确保锡（Tin）、钽（Tantalum）、钨（Tungsten）、金（Gold）（3TG），以及钴（Cobalt）、云母（Mica）、石墨（Graphite）、锂（Lithium）、镍（Nickel）与其他金属之来源符合本政策要求且可追溯。',
	commitLead: '为此，擎亿精密做出以下承诺：',
	sections: [
		{
			heading:
				'一、依循经济合作与发展组织（OECD）发布之《冲突影响与高风险地区矿产供应链尽职调查指南》，采行可被稽核与验证之尽职调查框架；并：',
			items: [
				'要求供应商回复责任矿产倡议（RMI）的 CMRT（Conflict Minerals Reporting Template）与 EMRT（Extended Minerals Reporting Template）揭露表单。',
				'据以审阅、汇整与保存资料，持续进行供应链风险监测与管理。'
			]
		},
		{
			heading:
				'二、清楚沟通并要求供应商确保产品中金属之来源可追溯且符合本政策，以确保整体供应链免于冲突矿产。',
			items: []
		},
		{
			heading: '三、透过以下方式落实供应链的冲突矿产管理：',
			items: [
				'制定冲突矿产政策。',
				'不购买从冲突地区来的冲突矿物。',
				'要求供应商签署《无冲突金属宣告书》。'
			]
		}
	],
	footnote:
		'要求供应商提供的原物料中不得间接或直接使用冲突矿产，必须遵循无冲突矿物的要求。如发现供应商之产品中有使用冲突矿产时，将采取必要措施停止使用该等冲突矿产。',
	company: '擎亿精密有限公司',
	companyEn: 'QingYi Precision Co., Ltd.'
};

export default locale;
